import React, { FC } from 'react';

import styles from 'buyside/components/presentation/JobVaultShowPage/JobVaultShowStats/jobVaultShowStatsStyles.scss';

const JobVaultShowStats: FC<{ stats: { data: string; label: string; Icon: any }[] }> = ({
  stats
}) => {
  return (
    <div className={styles.container}>
      {stats.map(
        ({ data, Icon, label }) =>
          data && (
            <div key={label} className={styles.statItem}>
              <Icon className={styles.statIcon} />
              <div>
                <div className={styles.statLabel}>{label}</div>
                <strong className={styles.statData}>{data}</strong>
              </div>
            </div>
          )
      )}
    </div>
  );
};

export default JobVaultShowStats;
